import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { NotificationComponent } from '../../../components/notification/notification.component';

import { TickerSymbolStatus } from '../ticker-symbol.domain';

@Component({
  selector: 'td-wb-ticker-symbol-notification',
  templateUrl: 'ticker-symbol-notification.component.html',
  imports: [
    TranslateDirective,
    NotificationComponent,
    HrefDirective
  ]
})
export class TickerSymbolNotificationComponent {
  readonly notificationStatus = input<TickerSymbolStatus>(undefined);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly SymbolStatus: typeof TickerSymbolStatus = TickerSymbolStatus;
}
